import React from 'react'
import { Jumbotron, Container, Col, Row } from 'reactstrap'
import './contact.css'
import mob from './mob.png'
import mail from './mail.png'

var Translate = require('react-translate-component')

export default class Contact extends React.Component {
  render () {
    return (
      <Jumbotron className='jumbotronContact'>
        <Container className='contactContent'>
          <h1 className='contactTitle'>
            <Translate content='kontakt' />
          </h1>
          <hr className='sectionTitleLine' />
          <p className='contactText'>
            <Translate content='mamy_nadzieje' />
          </p>
          <Row className='contactRow'>
            <Col md='6' xs='12'>
              <div className='contactLine'>
                <img src={mob} alt='mob'></img>
                <span className='contactData'>+48 501 375 425</span>
              </div>
            </Col>
            <Col md='6' xs='12'>
              <div className='contactLine'>
                <img src={mail} alt='mail'></img>
                <span className='contactData'>
                  <a href={'mailto:biuro@mtd.waw.pl'}>biuro@mtd.waw.pl</a>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </Jumbotron>
    )
  }
}
